<ng-container *ngFor="let toast of toasts$ | async; let i = index">
  <ea-toast [toast]="toast" (dispose)="remove(i)"></ea-toast>
</ng-container>
